module.exports = __webpack_public_path__ + "static/media/icon_mobismart.0558587a.png";